import type { AllRouteEndpoints } from "../routeTypes";
export const integrationsScimScimInstallCacheKeys: AllRouteEndpoints[] = ["/integrations/scim/scim_info"];
